export default "__VITE_ASSET__ba06e1ab__"